import { Nullable } from "~/types/general.types";

type ReplaceCmsVariables = (
  text: Nullable<string> | undefined,
  variables: Record<string, string | number | undefined | null>,
) => string | null;

export const replaceCmsVariables: ReplaceCmsVariables = (
  text,
  variables,
): string | null => {
  if (!text) {
    return null;
  }
  try {
    let resultText = text;

    Object.entries(variables).forEach(([key, value]) => {
      resultText = resultText?.split(`{{${key}}}`)?.join(String(value ?? ""));
    });

    return resultText;
  } catch (err) {
    return null;
  }
};
